<template>
  <div>
  <!-- Desktop View -->
  <div v-if="$vuetify.breakpoint.mdAndUp" class="table-wrapper">
    <v-data-table
      ref="dataTable"
      v-model="mySelectedIds"
      class="transparent text-no-wrap"
      dense
      :headers="headers"
      :items="contacts"
      :server-items-length="totalContacts"
      :options.sync="options"
      item-key="id"
      :loading="loadingTable"
      show-select
      :item-class="getRowClass"
      :footer-props="{
        itemsPerPageOptions: recordsPerPage,
      }"
    >
      <!-- Scroll Controls in Footer -->
      <template v-slot:footer.prepend>
        <div class="scroll-controls d-flex align-center">
          <v-btn
            icon
            small
            class="scroll-btn mr-1"
            title="Scroll Left"
            @click="scrollTable('left')"
          >
            <v-icon color="#37cf37">mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            class="scroll-btn"
            title="Scroll Right"
            @click="scrollTable('right')"
          >
            <v-icon color="#37cf37">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </template>
    <template v-slot:[`item.dispo`]="{ item }">
      <v-chip
        v-if="item.dnc || item.dispo == 'DNC'"
        :color="getColor('DNC')"
        text-color="white"
        close
        style="margin:5px; border-radius: 12px;"
        @click:close="rechurnDNC(item)"
      >
        <span style="font-size: 14px; color: #fafafa; font-weight: 400">
          DNC
        </span>
      </v-chip>

      <v-chip
        v-else
        :color="getColor(item.dispo || 'NEW')"
        dark
        style="margin:5px; border-radius: 12px;"
      >
        <span
          v-if="item.dispo == 'CALLBACK'"
          style="font-size: 14px; font-weight: 400"
        >
          {{ item.dispo }} ({{ $moment(item.callbackOn).format("lll") }})
        </span>
        <span v-else style="font-size: 14px; font-weight: 400">
          {{ item.dispo || 'NEW' }}
        </span>
      </v-chip>

      <v-chip
        v-if="item.smsSent"
        label
        color="yellow"
        text-color="white"
        style="margin:5px;"
      >
        <span style="font-size: 14px; color: #fafafa; font-weight: 400">
          SMS
        </span>
      </v-chip>

      <v-chip
        v-if="item.emailSent"
        label
        color="blue"
        text-color="white"
        style="margin:5px;"
      >
        <span style="font-size: 14px; color: #fafafa; font-weight: 400">
          Email
        </span>
      </v-chip>

      <v-chip
        v-if="item.linkSent"
        label
        color="green"
        text-color="white"
        style="margin:5px;"
      >
        <span style="font-size: 14px; color: #fafafa; font-weight: 400">
          Link
        </span>
      </v-chip>

      <v-chip
        v-if="item.appSent"
        label
        color="orange"
        text-color="white"
        style="margin:5px;"
      >
        <span style="font-size: 14px; color: #fafafa; font-weight: 400">
          App
        </span>
      </v-chip>
    </template>
    <template v-slot:[`item.leadScore`]="{ item }">
      <v-chip v-if="item.leadScore >= 0">
        <span class="happiness mr-2"> {{ getHappiness(item.leadScore) }}</span>
        <span class="score"> {{ item.leadScore }} </span>
      </v-chip>
    </template>
    <template v-slot:[`item.phone`]="{ item }">
      <a
        text
        class="dotted-gradient secondary--text"
        @click="openDetailsDialog(item)"
        >{{ item.phone }}</a
      >
    </template>

    <template v-slot:[`item.name`]="{ item }">
      <a
        text
        class="dotted-gradient secondary--text"
        @click="openDetailsDialog(item)"
        >{{ item.name }}</a
      >
    </template>

    <template v-slot:[`item.createdOn`]="{ item }">
      {{ $moment(item.createdOn).format("Do MMMM YYYY, h:mm A") }}
    </template>

    <template v-slot:[`item.dealValue`]="{ item }">
      {{ currency ? currency : "₹" }}
      {{ item.dealValue != undefined ? item.dealValue : 0 }}
    </template>

    <template v-slot:[`item.source_marketing`]="{ item }">
      <div v-if="item.source_marketing && typeof item.source_marketing === 'object'">
        <span v-if="item.source_marketing.source"><v-tooltip bottom><template v-slot:activator="{ on, attrs }"><strong v-bind="attrs" v-on="on" style="cursor:pointer">S:</strong></template><span>Source (utm_source)</span></v-tooltip> {{ item.source_marketing.source }}</span>
        <span v-if="item.source_marketing.campaign"> <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><strong v-bind="attrs" v-on="on" style="cursor:pointer">C:</strong></template><span>Campaign (utm_campaign)</span></v-tooltip> {{ item.source_marketing.campaign }}</span>
        <span v-if="item.source_marketing.medium && item.source_marketing.medium !== 'none'"> <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><strong v-bind="attrs" v-on="on" style="cursor:pointer">M:</strong></template><span>Medium (utm_medium)</span></v-tooltip> {{ item.source_marketing.medium }}</span>
        <span v-if="item.source_marketing.content && item.source_marketing.content !== 'none'"> <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><strong v-bind="attrs" v-on="on" style="cursor:pointer">Cn:</strong></template><span>Content (utm_content)</span></v-tooltip> {{ item.source_marketing.content }}</span>
        <span v-if="item.source_marketing.term && item.source_marketing.term !== 'none'"> <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><strong v-bind="attrs" v-on="on" style="cursor:pointer">T:</strong></template><span>Term (utm_term)</span></v-tooltip> {{ item.source_marketing.term }}</span>
        <span v-if="item.source_marketing.referrer && item.source_marketing.referrer !== 'none'"> <v-tooltip bottom><template v-slot:activator="{ on, attrs }"><strong v-bind="attrs" v-on="on" style="cursor:pointer">R:</strong></template><span>Referrer (document.referrer)</span></v-tooltip> {{ item.source_marketing.referrer }}</span>
      </div>
      <div v-else>
        {{ item.source_marketing }}
      </div>
    </template>

    <template v-slot:[`item.gopage_name`]="{ item }">
      <span v-if="item.source_marketing && item.source_marketing.pageName">
        {{ item.source_marketing.pageName }}
      </span>
      <span v-else>
        -
      </span>
    </template>

    <template v-slot:[`item.ip`]="{ item }">
      {{ item.ip ? item.ip : '-' }}
    </template>
    </v-data-table>
  </div>

  <!-- Mobile View -->
  <div v-if="!$vuetify.breakpoint.mdAndUp" class="mobile-view-container">
    <v-progress-linear
      v-if="loadingTable"
      indeterminate
      color="primary"
    ></v-progress-linear>

    <v-expansion-panels multiple flat class="mobile-contact-list">
      <v-expansion-panel
        v-for="item in contacts"
        :key="item.id"
        class="mb-2"
        :class="getRowClass(item)"
      >
        <v-expansion-panel-header class="py-2">
          <div class="d-flex align-center" style="width: 100%;">
            <v-checkbox
              :input-value="isItemSelected(item)"
              class="mt-0 pt-0 mr-2"
              hide-details
              @change="toggleSelection(item)"
              @click.stop
            ></v-checkbox>

            <div class="flex-grow-1">
              <!-- Phone Row -->
              <div class="d-flex justify-space-between align-center mb-1">
                <span class="caption grey--text">Phone</span>
                <a
                  text
                  class="dotted-gradient secondary--text font-weight-medium body-2"
                  @click.stop="openDetailsDialog(item)"
                >
                  {{ item.phone }}
                </a>
              </div>

              <!-- Name Row -->
              <div class="d-flex justify-space-between align-center mb-1">
                <span class="caption grey--text">Name</span>
                <a
                  text
                  class="dotted-gradient secondary--text body-2"
                  @click.stop="openDetailsDialog(item)"
                >
                  {{ item.name }}
                </a>
              </div>

              <!-- Dispo Row -->
              <div class="d-flex justify-space-between align-center">
                <span class="caption grey--text">Dispo</span>
                <div>
                  <v-chip
                    v-if="item.dnc || item.dispo == 'DNC'"
                    x-small
                    :color="getColor('DNC')"
                    text-color="white"
                    close
                    style="border-radius: 12px;"
                    @click:close="rechurnDNC(item)"
                  >
                    <span
                      style="font-size: 12px; color: #fafafa; font-weight: 400"
                    >
                      DNC
                    </span>
                  </v-chip>

                  <v-chip
                    v-else
                    x-small
                    :color="getColor(item.dispo)"
                    dark
                    style="border-radius: 12px;"
                  >
                    <span
                      v-if="item.dispo == 'CALLBACK'"
                      style="font-size: 12px; font-weight: 400"
                    >
                      {{ item.dispo }} ({{
                        $moment(item.callbackOn).format("lll")
                      }})
                    </span>
                    <span v-else style="font-size: 12px; font-weight: 400">
                      {{ item.dispo }}
                    </span>
                  </v-chip>

                  <v-chip
                    v-if="item.smsSent"
                    label
                    x-small
                    color="yellow"
                    text-color="white"
                    class="ml-1"
                  >
                    <span
                      style="font-size: 12px; color: #fafafa; font-weight: 400"
                    >
                      SMS
                    </span>
                  </v-chip>

                  <v-chip
                    v-if="item.emailSent"
                    label
                    x-small
                    color="blue"
                    text-color="white"
                    class="ml-1"
                  >
                    <span
                      style="font-size: 12px; color: #fafafa; font-weight: 400"
                    >
                      Email
                    </span>
                  </v-chip>

                  <v-chip
                    v-if="item.linkSent"
                    label
                    x-small
                    color="green"
                    text-color="white"
                    class="ml-1"
                  >
                    <span
                      style="font-size: 12px; color: #fafafa; font-weight: 400"
                    >
                      Link
                    </span>
                  </v-chip>

                  <v-chip
                    v-if="item.appSent"
                    label
                    x-small
                    color="orange"
                    text-color="white"
                    class="ml-1"
                  >
                    <span
                      style="font-size: 12px; color: #fafafa; font-weight: 400"
                    >
                      App
                    </span>
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div class="mobile-field-list">
            <div
              v-for="header in headers.filter(
                (h) => !['phone', 'name', 'dispo'].includes(h.value)
              )"
              :key="header.value"
              class="d-flex justify-space-between align-center py-2"
              style="border-bottom: 1px solid rgba(0,0,0,0.06);"
            >
              <span class="caption grey--text">{{ header.text }}</span>
              <span class="body-2 text-right" style="max-width: 60%;">
                <span
                  v-if="header.value === 'leadScore' && item.leadScore >= 0"
                >
                  <span class="happiness mr-1">{{
                    getHappiness(item.leadScore)
                  }}</span>
                  <span class="score">{{ item.leadScore }}</span>
                </span>
                <span v-else-if="header.value === 'createdOn'">
                  {{ $moment(item.createdOn).format("Do MMMM YYYY, h:mm A") }}
                </span>
                <span v-else-if="header.value === 'dealValue'">
                  {{ currency ? currency : "₹" }}
                  {{ item.dealValue != undefined ? item.dealValue : 0 }}
                </span>
                <span v-else>
                  {{ item[header.value] || "-" }}
                </span>
              </span>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Mobile Pagination -->
    <div class="text-center mt-4">
      <v-pagination
        v-model="options.page"
        :length="Math.ceil(totalContacts / options.itemsPerPage)"
        :total-visible="5"
      ></v-pagination>
      <v-select
        v-model="options.itemsPerPage"
        :items="recordsPerPage"
        label="Items per page"
        dense
        outlined
        class="mx-auto mt-2 customBorderRadius"
        style="max-width: 150px;"
      ></v-select>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
const _ = require("lodash");

export default {
  computed: {
    ...mapGetters(["dispoList", "ENDPOINT"]),
    ...mapState("dialer", ["currentNumber", "isInCall", "callStatus"]),
    headers: {
      get() {
        var head = this.$store.state.headers;
        var headvalue = _.uniq(head.map((h) => h.value));
        var filterHead = [];
        for (var h of headvalue) {
          var f = head.find((fh) => fh.value == h);
          filterHead.push(f);
        }
        return filterHead;
      },
      set(v) {
        this.$store.state.headers = v;
      },
    },
    currency() {
      return this.$store.getters.companyDetails.currency;
    },
    // Normalize the current dialer number for comparison
    normalizedCurrentNumber() {
      if (!this.currentNumber) return "";
      return this.currentNumber.replace(/[^0-9]/g, "");
    },
  },
  props: {
    contacts: {
      type: Array,
    },
    totalContacts: {
      type: Number,
    },
    loadingTable: {
      type: Boolean,
    },
    selectedIds: {
      type: Array,
    },
  },
  data() {
    return {
      recordsPerPage: [5, 20, 50, 100, 250, 500],
      page: 1,
      pageCount: 0,
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: [],
      },
      mySelectedIds: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.$emit("update", this.options);
        var paginate = {};
        paginate[
          this.$router.currentRoute.name
            .toString()
            .trim()
            .replace(/ /g, "")
            .toLowerCase()
        ] = this.options;
        this.$store.commit("setPagination", paginate);
      },
      deep: true,
    },
    mySelectedIds() {
      this.$emit("selectedIdUpdate", this.mySelectedIds);
    },
    selectedIds(newV) {
      this.mySelectedIds = newV;
    },
  },
  created() {
    var paginate = this.$store.getters.paginate;
    var routeName = this.$router.currentRoute.name
      .toString()
      .trim()
      .replace(/ /g, "")
      .toLowerCase();

    // Check if paginate exists for this route before accessing properties
    if (paginate && paginate[routeName]) {
      this.options.itemsPerPage = paginate[routeName].itemsPerPage || 5;
    } else {
      this.options.itemsPerPage = 5;
    }
    //this.options.sortBy = paginate[routeName].sortBy || "";
    //this.options.sortDesc = paginate[routeName].sortDesc || "";

    this.mySelectedIds = this.selectedIds;

    // Emit initial update to trigger data fetch
    this.$nextTick(() => {
      this.$emit("update", this.options);
    });
  },
  methods: {
    // Scroll table horizontally
    scrollTable(direction) {
      const dataTable = this.$refs.dataTable;
      const tableWrapper = dataTable && dataTable.$el && dataTable.$el.querySelector('.v-data-table__wrapper');
      if (tableWrapper) {
        const scrollAmount = 200;
        if (direction === 'left') {
          tableWrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          tableWrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }
    },
    // Rechurn DNC Contacts in list
    rechurnDNC(item) {
      this.loadingTable = true;
      var patchObj = {
        dispo: "",
        dnc: false,
        assignee: null,
        called: false,
        modifiedOn: new Date(),
      };
      this.$swal({
        title: "Are you sure?",
        text: "Remove this Contact from DNC?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1bca3f",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Remove it!",
      })
        .then((willDelete) => {
          if (willDelete.value) {
            this.$http
              .patch(`${this.ENDPOINT}/contacts/${item.id}`, patchObj)
              .then((response) => {
                this.loadingTable = false;
                this.$swal({ type: "success", text: "Successful" });
                this.$emit("update", this.options);
              })
              .catch((err) => {
                this.loadingTable = false;
                console.log("err", err);

                if (err.body.error.message.includes("is not unique")) {
                  this.$swal({
                    type: "error",
                    text: "Something Went Wrong Rechuning Contacts",
                  });
                } else {
                  this.$swal({ type: "error", text: err.body.error.message });
                }
              });
          } else {
            this.loadingTable = false;
          }
        })
        .catch((err) => {
          this.loadingTable = false;
          console.log(err);
        });
    },
    openDetailsDialog(item) {
      this.$emit("openDetailsDialog", item);
    },
    getRowClass(item) {
      // Check if this contact's phone matches the current call
      if (!this.currentNumber || !item.phone) return "";

      const isActiveCall =
        this.isInCall ||
        ["calling", "ringing", "connected"].includes(this.callStatus);

      if (!isActiveCall) return "";

      // Normalize both numbers for comparison (remove non-digits)
      const itemPhone = item.phone.replace(/[^0-9]/g, "");
      const currentPhone = this.normalizedCurrentNumber;

      // Check if numbers match (either exact or one ends with the other)
      if (
        itemPhone === currentPhone ||
        itemPhone.endsWith(currentPhone) ||
        currentPhone.endsWith(itemPhone)
      ) {
        return "currently-calling-row";
      }

      return "";
    },
    getColor(dispo) {
      const self = this;
      try {
        if (dispo == "NEW") return "primary";
        var d = _.find(self.dispoList, (d) => {
          return d.title == dispo;
        });
        if (d == undefined) {
          return "#E5E5E5";
        }
        return d.hex;
      } catch (e) {
        console.log("error", e);
      }
    },
    getHappiness(internalValue) {
      let moods = [
        "😡",
        "😠",
        "😦",
        "😟",
        "🙁",
        "😐",
        "🙂",
        "😊",
        "😄",
        "😃",
        "😍",
      ];

      if (internalValue == 0) {
        return "🤬";
      }
      // this.$emit('filter', filterData);

      return moods[Math.floor(internalValue / 10)];
    },
    isItemSelected(item) {
      // Check if item is in mySelectedIds array
      return this.mySelectedIds.some((selectedItem) => {
        // Compare by id if both have id property
        if (selectedItem.id && item.id) {
          return selectedItem.id === item.id;
        }
        // Otherwise do direct comparison
        return selectedItem === item;
      });
    },
    toggleSelection(item) {
      const index = this.mySelectedIds.findIndex((selectedItem) => {
        if (selectedItem.id && item.id) {
          return selectedItem.id === item.id;
        }
        return selectedItem === item;
      });

      if (index > -1) {
        // Remove item
        this.mySelectedIds.splice(index, 1);
      } else {
        // Add item
        this.mySelectedIds.push(item);
      }
    },
  },
};
// field fieldType search customFieldDate min max selectedDispo
</script>

<style>
/* Table Scroll Controls */
.table-wrapper {
  width: 100%;
}

.scroll-controls {
  margin-right: auto;
}

.scroll-btn {
  border: 1px solid #e0e0e0;
  border-radius: 8px !important;
  background: #fff !important;
  transition: all 0.2s ease;
}

.theme--dark .scroll-btn {
  background: #2d2d2d !important;
  border-color: #404040 !important;
}

.scroll-btn:hover {
  border-color: #37cf37;
  background: rgba(55, 207, 55, 0.05) !important;
}

.theme--dark .scroll-btn:hover {
  background: rgba(55, 207, 55, 0.1) !important;
}

.scroll-btn .v-icon {
  color: #37cf37 !important;
}

/* Subtle highlight for currently calling contact row */
.currently-calling-row {
  background-color: rgba(76, 175, 80, 0.08) !important;
  box-shadow: inset 3px 0 0 0 #4caf50;
}

.currently-calling-row td {
  background-color: transparent !important;
  position: relative;
}

/* Subtle pulsing glow on the phone number cell */
.currently-calling-row td:nth-child(3) {
  animation: subtle-pulse 2s ease-in-out infinite;
}

@keyframes subtle-pulse {
  0%,
  100% {
    color: inherit;
  }
  50% {
    color: #4caf50;
  }
}

/* Small calling indicator dot */
.currently-calling-row td:first-child::after {
  content: "";
  position: absolute;
  right: -2px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #4caf50;
  border-radius: 50%;
  animation: dot-pulse 1.5s ease-in-out infinite;
}

@keyframes dot-pulse {
  0%,
  100% {
    transform: translateY(-50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateY(-50%) scale(1.2);
    opacity: 0.7;
  }
}

/* Mobile Contact List Styles */
.mobile-view-container {
  background-color: transparent !important;
}

.mobile-contact-list {
  background-color: transparent !important;
  min-height: 205px;
}

.mobile-contact-list .v-expansion-panel {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px !important;
  background-color: #fff !important;
}

.mobile-contact-list .v-expansion-panel::before {
  box-shadow: none;
}

.mobile-contact-list .v-expansion-panel-header {
  min-height: auto !important;
  padding: 8px 12px !important;
  background-color: #fff !important;
}

.mobile-contact-list .v-expansion-panel-content__wrap {
  padding: 8px 12px !important;
  /* background-color: #fff !important; */
}

/* Mobile calling highlight */
.mobile-contact-list .currently-calling-row {
  background-color: rgba(76, 175, 80, 0.08) !important;
  border-left: 4px solid #4caf50 !important;
}

/* Mobile field list styling */
.mobile-field-list {
  padding: 4px 0;
}

.mobile-field-list > div:last-child {
  border-bottom: none !important;
}
</style>
